export const pastEvents = [
    {
        id: "exampleModalp1",
        card: {
            src: "./images/events/GenSD-Webinar1.jpg",
            alt: "GenSD Webinar"
        },
        modalImage: "./images/events/GenSD-Webinar1.jpg",
        title: "GenSD Webinar",
        description: "National level webinar organised by NCC IIT Roorkee for the NCC cadets all across India.",
        date: "Date & Time - 10-04-2021, 6 PM",
        venue: "Venue - Online"
    },
    {
        id: "exampleModalp2",
        card: {
            src: "./images/events/KVDquiz.png",
            alt: "KVD Quiz Event"
        },
        modalImage: "./images/events/KVDquiz.png",
        title: "Kargil Vijay Diwas Quiz",
        description: "An Intra NCC Quiz to enhance the knowledge of fellow cadets about Kargil War.",
        date: "Date - 26-07-2021",
        venue: "Venue - Online",
        resultLink: "https://docs.google.com/spreadsheets/d/1n2l2D7ewfmkFWlYfaPYZ6nJU6sIgF0i8oOcs4SI2_-Y/edit#gid=0"
    },
    {
        id: "exampleModalp3",
        card: {
            src: "./images/events/Pentathlon.png",
            alt: "Pentathlon Event"
        },
        modalImage: "./images/events/pentathlonwinners.png",
        title: "Pentathlon",
        description: "NCC IIT Roorkee conducted Pentathlon - an event consisting of five different games: Wall Magazine, Tug of War, March and Past, March and Past with Arms and a Quiz, for the first years with a motive to introduce them to NCC.",
        date: "Date - 14-08-2021",
        venue: "Venue - Infront of SAC, IIT Roorkee"
    },
    {
        id: "exampleModalp4",
        card: {
            src: "./images/events/Run.jpg",
            alt: "Run Event"
        },
        modalImage: "./images/events/Run.jpg",
        title: "Run for Unity",
        description: "A small run was organized from Student's Activity Center to Main Building Gate, with strength of 50+ to commemorate the birth anniversary of Sardar Vallabhbhai Patel.",
        date: "Date - 31-10-2021",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp5",
        card: {
            src: "./images/events/hd.png",
            alt: "HD Event"
        },
        modalImage: "./images/events/hd.png",
        title: "Hindi Diwas",
        description: "प्रत्येक वर्ष 14 सितम्बर को हिंदी दिवस मनाया जाता है। इस दिन ही भारत की संविधान सभा ने हिंदी को भारत गणराज्य की आधिकारिक भाषा घोषित किया था। इस हिंदी दिवस पर एन. सी. सी आई. आई. टी. रुड़की आप सभी के लिए एक हिंदी वाचन प्रतियोगिता प्रस्तुत कर रहा है।",
        date: "Date - 12-09-2021",
        venue: "Venue - Online"
    },
    {
        id: "exampleModalp6",
        card: {
            src: "./images/events/quiz.jpg",
            alt: "Quiz Event"
        },
        modalImage: "./images/events/quiz.jpg",
        title: "Quizzard",
        description: "On 26th January 2022, NCC IIT Roorkee celebrates the 73rd Republic Day of India with much enthusiasm and heartfelt gratitude to the heroic sons of Mother India whose ceaseless determination and unending valor lead to the transformation of the country into a sovereign nation. It is a day to celebrate the essence of liberty, pay homage to our constitution and help India accomplish its freedom fighters' dreams.",
        date: "Date & Time - 26-01-2022, 9 PM",
        venue: "Venue - D2C",
        extraInfo: "Last date of registration - 26-01-2022, 8 PM"
    },
    {
        id: "exampleModalp7",
        card: {
            src: "./images/events/marathon.jpg",
            alt: "Marathon Event"
        },
        modalImage: "./images/events/marathon.jpg",
        title: "Fresher's Marathon",
        description: "NCC IIT Roorkee is organizing a 'Freshers marathon' for all IITR students on 5th February 2022. The marathon would be 5 KM for both boys and girls. We have a cash prize of ₹6000, and the top 5 runners will get T-Shirts and there are Certificates of participation for all those who complete the marathon.",
        date: "Date - 05-02-2022",
        venue: "Venue - Anywhere",
        extraInfo: "Last date of registration - 04-02-2022"
    },
    {
        id: "exampleModalp8",
        card: {
            src: "./images/events/bdc.jpeg",
            alt: "BDC Event"
        },
        modalImage: "./images/events/bdc.jpeg",
        title: "Blood Donation Camp",
        description: "Blood Donation is a noble cause. Keeping this in mind, NCC in collaboration with NSS IIT Roorkee, conducted a blood donation camp. Maa Ganga Blood Centre, IMA Dehradun and Mother Teresa Blood Bank were invited. The combined collection was nearly 850+ units. Mr Suresh Kumar Saini, a world record holder in the number of times he has donated blood graced the occasion as the chief guest of the occasion.",
        date: "Date - 07-04-2022",
        venue: "Venue - SAC, 1st Floor"
    },
    {
        id: "exampleModalp9",
        card: {
            src: "./images/events/yoga.jpg",
            alt: "Yoga Event"
        },
        modalImage: "./images/events/yoga.jpg",
        title: "Yoga Sadna",
        description: "Yoga is the journey of the self, through the self, to the self. To give a mirror to look at from within, NCC IIT Roorkee organized Yoga Sadhna, a mass yoga event at LBS Stadium. The event saw a huge participation of nearly 1200 participation from the IIT R community. T-shirts and refreshments were given. The chief guest of the occasion was the Deputy Director of IIT Roorkee, Dr Manoranjan Parida.",
        date: "Date & Time - 17-04-2022, 5:30 AM",
        venue: "Venue - LBS Stadium"
    },
    {
        id: "exampleModalp10",
        card: {
            src: "./images/events/fc.png",
            alt: "BEG Visit"
        },
        modalImage: "./images/events/fc.png",
        title: "BEG Visit",
        description: "NCC IIT Roorkee had conducted a visit to one of the oldest regiments in the Indian military, the Bengal Sappers, which is stationed in Roorkee and is trained by the Bengal Engineers Group (BEG). This visit was full of pride and ardour as the students got an opportunity to experience how our warriors train with fervour. They were made to have a tour of the military school, army labs, regiment parade ground, where they witnessed the daily procession of the army unit. They were exhibited many military weapons and tanks. NCC also paid a visit to the the regiment's war memorial, where the anecdotes of many brave soldiers were portrayed.",
        date: "Date - 06-08-2022",
        venue: "Venue - BEG, Roorkee"
    },
    {
        id: "exampleModalp11",
        card: {
            src: "./images/events/vfl.png",
            alt: "Vocal For Local"
        },
        modalImage: "./images/events/vfl.png",
        title: "Vocal for Local",
        description: "Today is a historic day with regard to the freedom struggle. It was the day when people from all parts of India and from all religious groups, came to streets, demanding poorna swaraj and complete end of British rule. It was this campaign which shook the roots of British Empire and paved the way for swaraj(self-rule). On this significant occasion, NCC organised a 'Vocal for Local' rally across the IITR campus celebrating this remarkable event and also creating awareness about 'Vocal for Local' as in today's world self dependency in true swaraj.",
        date: "Date - 09-08-2022",
        venue: "Venue - IITR Campus"
    },
    {
        id: "exampleModalp12",
        card: {
            src: "./images/events/trdd.png",
            alt: "Guard Of Honour"
        },
        modalImage: "./images/events/trdd.png",
        title: "Guard of Honour",
        description: "This year's Independence day was special, as we were celebrating 75 years of independence. This special occasion implored for a grand celebration. Being a part of the celebration, NCC IIT Roorkee organised various events to commemorate the occasion. NCC's guard of honour, which has always been the centre of attraction of The Independence day, graced the event. NCC also conducted a seminar on 'Partition Horrors Remembrance', which took us back to the dreadful days of partition.",
        date: "Date & Time - 15-08-2022, 9:00 AM",
        venue: "Venue - Thomso Ground"
    },
    {
        id: "exampleModalp13",
        card: {
            src: "./images/events/26Jan2023.jpeg",
            alt: "Guard Of Honour"
        },
        modalImage: "./images/events/26Jan2023.jpeg",
        title: "Guard of Honour",
        description: "This year's Republic Day celebration at IIT Roorkee was marked with patriotic fervor and memorable events organized by NCC IIT Roorkee. The event began with the cadet's guard of honor, showcasing their discipline and precision, capturing the admiration of all attendees. The day celebrated the spirit of the Indian Republic, fostering national pride and unity among participants. The commendable efforts of the cadets made the day memorable for all.",
        date: "Date & Time - 26-01-2023, 9:00 AM",
        venue: "Venue - Thomso Ground"
    },
    {
        id: "exampleModalp14",
        card: {
            src: "./images/events/selfDef.jpeg",
            alt: "Self Defence Workshop"
        },
        modalImage: "./images/events/self.Def.jpeg",
        title: "Self Defence Workshop",
        description: '"The purpose of self-defence is not to win a fight, but to prevent one." - Bruce Lee\nJoin us for a hands-on Self-Defence Workshop on 19th March 2023, starting at 5:00 PM onwards at the Taekwondo Club Floor. This workshop is being organized by NCC IIT Roorkee in collaboration with the Taekwondo Club IIT Roorkee.',
        date: "Date & Time - 19-03-2023, 5:00 PM",
        venue: "Venue - Taekwondo Club area, above central gym"
    },
    {
        id: "exampleModalp15",
        card: {
            src: "./images/events/atomic.jpg",
            alt: "Atomic Artistry"
        },
        modalImage: "./images/events/atomicWinner.jpg",
        title: "Pokhran II Nuclear Test Painting Competition",
        description: "Winners<br />1st : Mr. Nikita Tripathi<br />2nd : Mr. Cheerag Shridhar<br />3rd : Mr. Shrey Agrawal",
        date: "Date & Time - 13-05-2023",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp16",
        card: {
            src: "./images/events/flood-donation2023.jpg",
            alt: "Flood Relief Donation Drive"
        },
        modalImage: "./images/events/flood-donation2023.jpg",
        title: "Flood Relief Donation Drive",
        description: "In the guidance of the traditional values of helping the needy, NCC and NSS, IIT Roorkee came together to contribute to the flood affected society in collaboration with the IX Battalion The Jat Regiment. The donation, collected from the residents of IIT Roorkee, was was distributed on 5th August at The Bengal Engineers Group centre, Roorkee. The grace of the occassion was enhanced by the presence of the Commandant of BEG centre himself.",
        date: "Date - 18-06-2023",
        venue: "Venue - Roorkee"
    },
    {
        id: "exampleModalp17",
        card: {
            src: "./images/events/tree-plantation2023.jpg",
            alt: "Tree Plantation Drive"
        },
        modalImage: "./images/events/tree-plantation-2023.jpg",
        title: "Tree Plantation Drive",
        description: "On August 13th, NCC, Institute Works Department, and the Green Committee joined forces on August 13th for a tree planting event. This collaboration aimed to promote nature appreciation within the campus. Volunteers from various backgrounds planted saplings around the ABN Ground, symbolizing environmental commitment and inspiring a connection with nature for future generations.",
        date: "Date - 13-08-2023",
        venue: "Venue - ABN Ground"
    },
    {
        id: "exampleModalp18",
        card: {
            src: "./images/events/15aug2023.jpg",
            alt: "Guard Of Honour"
        },
        modalImage: "./images/events/15aug-2023.jpg",
        title: "Guard Of Honour",
        description: "This year's Independence Day celebration at IIT Roorkee resonated with patriotic zeal and memorable events organized by NCC IIT Roorkee. The festivities commenced with a solemn flag hoisting ceremony, symbolizing our nation's freedom and sovereignty, evoking deep reverence among all present. The day embodied the essence of India's independence struggle, igniting a sense of pride and unity among the participants. The unwavering dedication of the cadets made the occasion truly unforgettable for everyone involved.",
        date: "Date & Time - 15-08-2023, 9:00 AM",
        venue: "Venue - Thomso Ground"
    },
    {
        id: "exampleModalp19",
        card: {
            src: "./images/events/BDC2023.jpeg",
            alt: "BDC Event"
        },
        modalImage: "./images/events/BDC2023.jpeg",
        title: "Blood Donation Event",
        description: "Join us for a Lifesaving Mission!<br />Are you ready to make a difference?<br />On this Sunday, the 8th of October, NCC IIT Roorkee has made arrangements for a Blood Donation Camp on campus at SAC. Join us as we put our hands together towards the future of the country. Let's come together, unite our strengths, donate blood and create a ripple effect of kindness that will touch countless lives. See you there on the Sunday!",
        date: "Date & Time - 08-10-2023, 10:00 AM",
        venue: "Venue - SAC, IITR"
    },
    {
        id: "exampleModalp20",
        card: {
            src: "./images/events/catc2023.jpg",
            alt: "CATC"
        },
        modalImage: "./images/events/catc2023.jpg",
        title: "CATC",
        description: "Combined Annual Training Camp, which was a significant event organized by the National Cadet Corps (NCC) in IIT Roorkee. CATC camps serve as platforms for cadets to undergo intensive training in a structured environment. This camp features NCC IIT Roorkee cadets and other cadets from nearby colleges in Haridwar District under the 3 UK CTR NCC Roorkee.",
        date: "Date - 27-11-2023 to 05-12-2023",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp21",
        card: {
            src: "./images/events/26Jan2024.jpeg",
            alt: "Guard of Honour on Republic Day"
        },
        modalImage: "./images/events/26Jan2024.jpeg",
        title: "GoH 26 Jan 2024",
        description: "This year's Republic Day celebration at IIT Roorkee reverberated with patriotic fervor and remarkable events orchestrated by NCC IIT Roorkee. The day commenced with a dignified flag hoisting ceremony, symbolizing the spirit of our nation's democratic values and unity in diversity, evoking profound respect among all attendees. The unwavering commitment of the cadets made the event truly memorable and resonant for all who were part of it.",
        date: "Date & Time - 26-01-2024, 9:00 AM",
        venue: "Venue - Thomso Ground"
    },
    {
        id: "exampleModalp22",
        card: {
            src: "./images/events/megaFoodDrive.jpeg",
            alt: "Food Donation Drive with Robin Hood Army"
        },
        modalImage: "./images/events/megaFoodDrive.jpeg",
        title: "Mega Food Drive",
        description: "In a heartwarming act of kindness, NCC IIT Roorkee collaborated with the Robinhood Army to provide more than 100 food packets packed with essential nourishment to families residing in the IIT Roorkee Labour Camp on 20th of March, 2024. Moreover, this collaborative effort brought joy to children's faces by distributing toys and teddy bears.<br />A dedicated team of 25 cadets from NCC IIT Roorkee stood by, spreading hope throughout the community every step of the way.",
        date: "Date - 20-03-2024",
        venue: "Venue - Bhangeri, Roorkee"
    },
    {
        id: "exampleModalp23",
        card: {
            src: "./images/events/BEG2024.jpeg",
            alt: "BEG Visit"
        },
        modalImage: "./images/events/BEG2024.jpeg",
        title: "BEG Visit",
        description: '20 cadets from 3 UK CTR NCC Roorkee visited the Bengal Engineers Group and Center, Roorkee at the annual event "Exercise Jal Taranga", organised by the Bengal Sappers. The event was conducted gracefully by showcasing the task of corps of engineers in Indian Army during war and peace times.<br />NCC IIT Roorkee hails the sappers who, by implementation of their knowledge, serve the nation and leave no stone unturned to neutralise the enemy.<br />Jai Hind!',
        date: "Date & Time - 10-04-2024, 8:00 AM",
        venue: "Venue - BEG, Roorkee"
    },
    {
        id: "exampleModalp24",
        card: {
            src: "./images/events/15aug-2024.jpg",
            alt: "Guard of Honour on Independence Day"
        },
        modalImage: "./images/events/15aug-2024.jpg",
        title: "GoH 15th Aug",
        description: 'At the stroke of the midnight hour, when the world sleeps, India will awake to life and freedom—Jawaharlal Nehru<br />Today, we paint the skies with vibrant hues of saffron, white, and green as our hearts swell with pride and patriotism. We raise our tricolour high and sing our anthem with fervor while honoring the legacy of those who fought for our right to self-determination. The air is filled with the echoes of their dreams and the promise of a united, prosperous India reaching new heights in every field as we uphold our claim of "Incredible India".',
        date: "Date & Time - 15-08-2024, 9:00 AM",
        venue: "Venue - Thomso Ground"
    },
    {
        id: "exampleModalp25",
        card: {
            src: "./images/events/space-day-2024.jpg",
            alt: "National Space Day"
        },
        modalImage: "./images/events/space-day-2024.jpg",
        title: "Space Day",
        description: "Are you ready to embark on an extraordinary adventure through space on first National Space Day with us?<br />On this Saturday, 24th August 2024, NCC IIT Roorkee is organising an exciting workshop in collaboration with Centre for Space, Science and Technology to commemorate the one year anniversary of the successful landing of Chandrayaan-3 on the lunar surface. Join us to explore the wonders of space in this engaging, hands-on workshop designed for participants of all ages.",
        date: "Date & Time - 24-08-2024, 3:00 PM",
        venue: "Venue - DoMS - LH-1"
    },
    {
        id: "exampleModalp26",
        card: {
            src: "./images/events/cadet-bharti2024.jpg",
            alt: "Cadet Bharti"
        },
        modalImage: "./images/events/cadet-bharti2024.jpg",
        title: "Cadet Bharti",
        description: "Join us for the annual Cadet Bharti where new cadets are inducted with pride and zeal. Experience the spirit and camaraderie of NCC as we welcome the next generation of leaders.",
        date: "Date & Time - 05-09-2024, 08:00 AM",
        venue: "Venue - Football Grounds"
    },
    {
        id: "exampleModalp27",
        card: {
            src: "./images/events/gandhi-jayanti-quiz-2024.jpg",
            alt: "Gandhi Jayanti (Quiz Competition)"
        },
        modalImage: "./images/events/gandhi-jayanti-quiz-2024.jpg",
        title: "Gandhi Jayanti Quiz Competition",
        description: "Celebrate Gandhi Jayanti with an engaging quiz that tests your knowledge about the life and values of Mahatma Gandhi.",
        date: "Date & Time - 02-10-2024, 09:00 AM - 11:00 PM",
        venue: "Venue - Online"
    },
    {
        id: "exampleModalp29",
        card: {
            src: "./images/events/firing-practice-2024.jpg",
            alt: "Firing Practice (in BEG) - 9th October"
        },
        modalImage: "./images/events/firing-practice-2024.jpg",
        title: "Firing Practice",
        description: "Participate in an immersive firing practice session at BEG to improve your precision and control.",
        date: "Date & Time - 09-10-2024, 02:00 PM",
        venue: "Venue - BEG Firing Range"
    },
    {
        id: "exampleModalp30",
        card: {
            src: "./images/events/blood-donation-camp-2024.jpg",
            alt: "Blood Donation Camp - 20th October"
        },
        modalImage: "./images/events/blood-donation-camp2024.jpg",
        title: "Blood Donation Camp",
        description: "Join us in making a difference at our Blood Donation Camp. Your contribution can save lives and strengthen our community.",
        date: "Date & Time - 20-10-2024, 08:00 AM Onwards",
        venue: "Venue - SAC OAT"
    },
    {
        id: "exampleModalp31",
        card: {
            src: "./images/events/quiz-drawing-competition2024.jpg",
            alt: "Quiz and Drawing Competition (Constitution Day) - 11th November"
        },
        modalImage: "./images/events/quiz-drawing-competition2024.jpg",
        title: "Quiz & Drawing Competition",
        description: "Celebrate Constitution Day by engaging in a quiz and drawing competition that honors the spirit of our nation.",
        date: "Date & Time - 11-11-2024, 11:00 AM",
        venue: "Venue - APJ Abdul Kalam Block"
    },
    {
        id: "exampleModalp32",
        card: {
            src: "./images/events/run-for-fun2024.jpg",
            alt: "Run for Fun (NCC Day Celebration with 3uk ctr NCC Unit) - 17th November"
        },
        modalImage: "./images/events/run-for-fun-2024.jpg",
        title: "Run for Fun",
        description: "Get ready for a fun-filled run as we celebrate NCC Day with energy and enthusiasm. Join the race and showcase your team spirit.",
        date: "Date & Time - 17-11-2024, 07:00 AM",
        venue: "Venue - ABN Ground"
    },
    {
        id: "exampleModalp33",
        card: {
            src: "./images/events/catc-camp-2024.jpg",
            alt: "CATC CAMP - 29th Nov to 8th Dec"
        },
        modalImage: "./images/events/catc-camp2024.jpg",
        title: "CATC CAMP",
        description: "Experience an intense and transformative camp at CATC from 29th November to 8th December. A perfect blend of discipline, training, and camaraderie awaits you.",
        date: "Date & Time - 29-11-2024 to 08-12-2024"
    },
    {
        id: "exampleModalp34",
        card: {
            src: "./images/events/26jan2025.jpg",
            alt: "Guard Of Honour on Republic Day"
        },
        modalImage: "./images/events/26jan2025-rec.jpg",
        title: "Guard Of Honour on Republic Day",
        description: "Celebrate the pride of our nation as we perform a majestic Guard Of Honour on Republic Day.",
        date: "Date & Time - 26-01-2025, 8:45 AM",
        venue: "Venue - In front of the Main Building, IIT Roorkee"
    },
    {
        id: "exampleModalp35",
        card: {
            src: "./images/events/guest-lec-col-anoop.jpg",
            alt: "Guest Lecture by Col. Anoop Vyas"
        },
        modalImage: "./images/events/guest-lec-col-anoop-rec.jpg",
        title: "Guest Lecture by Col. Anoop Vyas",
        description: 'Our unit\'s CO, Col. Anoop Vyas, delivered an inspiring guest lecture on "The Role of Engineers Corps: The Less Spoken Heroes of the Indian Armed Forces".',
        date: "Date & Time - 29th Jan 4:30 PM",
        venue: "Venue - Chemical Auditorium, IIT Roorkee"
    },
    {
        id: "exampleModalp36",
        card: {
            src: "./images/events/eyehealthcamp2.jpg",
            alt: "Eye and health checkup camp"
        },
        modalImage: "./images/events/eyehealthcamp.jpg",
        title: "Eye Checkup Camp",
        description: "Good vision is key to a better life, and regular eye checkups are essential for maintaining healthy eyesight. Join NCC IIT Roorkee at Free Eye and Health Checkup Camp to ensure your well-being where experienced doctors will conduct comprehensive eye and health tests, providing expert guidance; absolutely free.",
        date: "Date & Time - 26-02-2025, 09:00 AM",
        venue: "Venue - Students Activity Center, IIT Roorkee"
    },
    {
        id: "exampleModalp37",
        card: {
            src: "./images/events/Firing-25.jpeg",
            alt: "Firing Practice"
        },
        modalImage: "./images/events/firing-competition.jpg",
        title: "Firing Practice",
        description: "A total of 49 NCC IIT Roorkee cadets participated in a firing practice session at the Bengal Engineer Group (BEG), Roorkee. Each cadet completed 5 rounds of Grouping Fire and 5 rounds of Snap Shooting, improving precision, control, and target response. The session offered valuable hands-on experience in a military setting.",
        date: "Date & Time - 7th April 2025, 2:00 PM",
        venue: "Venue - BEG Firing Range"
    },
    {
        id: "exampleModalp38",
        card: {
            src: "./images/events/AAD-25-2.jpg",
            alt: "Recreational Activity At AAD"
        },
        modalImage: "./images/events/AAD-25-3.jpg",
        title: "Recreational Activity At AAD",
        description: "NCC IITR brought a day full of joy, inclusion, and energy to Anushruti Academy for the Deaf. Through 7 engaging games, over 90 students participated with enthusiasm and spirit. The event celebrated not just play, but confidence and connection—ending with 22 bright winners and countless smiles.",
        date: "Date & Time - 9th April 2025, 9:00 AM - 1:00 PM",
        venue: "Venue - AAD"
    },
    {
        id: "exampleModalp39",
        card: {
            src: "./images/events/CatcJuly25.png",
            alt: "Catc July camp"
        },
        modalImage: "./images/events/CatcJuly25.png",
        title: "CATC July Camp",
        description: "An intensive 10-day training camp at CATC, running from the 6th of July to the 15th July. This program is designed to foster personal growth through a structured blend of physical discipline, skill-based training, and the development of strong camaraderie among participants.",
        date: "Date : 06-07-2025 to 15-07-2025",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp40",
        card: {
            src: "./images/events/15aug-2025.png",
            alt: "Guard of Honour on Independance Day"
        },
        modalImage: "./images/events/IndependenceDayGOH2025_modal.jpeg",
        title: "Guard of Honour on Independence Day",
        description: "As the nation prepares to celebrate its 79th Independence Day, NCC IIT Roorkee warmly invites you to join us and be a part of this historic morning as the cadets of 10 UK Bn NCC, IIT Roorkee, present the Guard of Honour and witness the National Flag hoisted with full ceremonial honours.",
        date: "Date & Time - 15th August 2025, 8:45 AM",
        venue: "Venue - James Thomson Building"
    },
    {
        id: "exampleModalp41",
        card: {
            src: "./images/events/cdt_enrollment_modal.jpeg",
            alt: "Cadet Enrollment 2025"
        },
        modalImage: "./images/events/cdt_enrollment_modal.jpeg",
        title: "Enrollment of Cadets 2025",
        description: "NCC IIT Roorkee invites motivated and disciplined students to participate in the NCC Cadet Enrolment Programme. This enrolment drive offers an opportunity to become part of the National Cadet Corps and begin a journey rooted in discipline, leadership, and service to the nation",
        date: "Date & Time - 31st August, 2025",
        venue: "Venue - FootBall Ground"
    },
    {
        id: "exampleModalp42",
        card: {
            src: "./images/events/FloodDonationDrive-poster.jpg",
            alt: "Flood Donation Drive"
        },
        modalImage: "./images/events/FloodDonationDrive-modal.jpg",
        title: "Flood Donation Drive",
        description: "NCC IIT Roorkee is organising a Flood Relief Donation Drive to support the people of Dehradun and nearby areas affected by floods and cloudbursts. Families have lost homes, belongings, and essentials, and your contribution can bring them hope and relief.",
        date: "Date - 22-09-2025 to 25-09-2025",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp43",
        card: {
            src: "./images/events/gd-and-quiz.jpg",
            alt: "Group Discussion and Quiz competition"
        },
        modalImage: "./images/events/gd-and-quiz.jpg",
        title: "Group Discussion and Quiz competition",
        description: "As part of the Swachhata Hi Seva (SHS) campaign, NCC IIT Roorkee is organizing a Group Discussion on the topics of social responsibility, sustainability and nation-building, and an Offline Interactive Mentimeter Quiz testing your knowledge of Gandhiji's life and the Swachh Bharat Mission.",
        date: "Date & Time - 28th September 2025",
        venue: "Venue - LHC"
    },
    {
        id: "exampleModalp44",
        card: {
            src: "./images/events/Idea_and_innovation.png",
            alt: "CATC Camp"
        },
        modalImage: "./images/events/Idea_and_innovation.png",
        title: "Idea and Innovation competition",
        description: "NCC IIT Roorkee participated in the Idea & Innovation Competition (IIC) organised by HQ DG NCC, where cadets presented low-cost, real-world impact project ideas. Five teams from RK Group represented IIT Roorkee and RIT College across stages held at Dehradun and Vijayawada. The event provided national exposure, full institutional support, and culminated in national-level recognition with Certificates of Appreciation from DG NCC.",
        date: "",
        venue: ""
    },
    {
        id: "exampleModalp45",
        card: {
            src: "./images/events/CatcCamp26nov-5dec.jpg",
            alt: "CATC Camp"
        },
        modalImage: "./images/events/CatcCamp26nov-5dec.jpg",
        title: "CATC Camp",
        description: "Ten days. Countless drills. One spirit. Wrapping up a successful Combined Annual Training Camp (CATC) held from Nov 26 to Dec 5, 2025. We walked in as individuals, but we leave as a team. Proud of every cadet who gave their all.",
        date: "Date - 26-11-2025 to 5-12-2025",
        venue: "Venue - IIT Roorkee"
    },
    {
        id: "exampleModalp49",
        card: {
            src: "./images/events/essay-writing.png",
            alt: "Essay Writing Competition"
        },
        modalImage: "./images/events/essay-writing.png",
        title: "Essay Writing Competition",
        description: 'NCC IIT Roorkee organized an offline Essay Writing Competition on the theme "Clean Election – Green Election" to promote awareness about sustainable electoral practices and environmental consciousness among students. The event provided a platform for participants to express their ideas on creating eco-friendly and transparent electoral systems.',
        date: "Date - 25 January 2026",
        venue: "Venue - APJ 201 & 202, IIT Roorkee",
        resultLink: "https://channeli.in/noticeboard/notice/19230"
    },
    {
        id: "exampleModalp50",
        card: {
            src: "./images/events/Slogan-Poster.jpg",
            alt: "Slogan Competition"
        },
        modalImage: "./images/events/Slogan-Poster.jpg",
        title: "Slogan Competition",
        description: "On the occasion of the 16th National Voter's Day, NCC IIT Roorkee, in collaboration with Election Commission, IIT Roorkee, invites all students to take part in democracy-themed slogan competitions that celebrate voting, awareness, and responsibility.",
        date: "Date - 26 January 2026",
        venue: "Venue - Online Mode",
        resultLink: "https://channeli.in/noticeboard/notice/19230"
    },
    {
        id: "exampleModalp51",
        card: {
            src: "./images/events/Instagram-reel-competition.jpg",
            alt: "Instagram Reel Competition"
        },
        modalImage: "./images/events/Instagram-reel-competition.jpg",
        title: "Instagram Reel Competition",
        description: "On the occasion of the 16th National Voter's Day, NCC IIT Roorkee, in collaboration with the Election Commission, IIT Roorkee, hosted a Reel Competition under the theme \"Sugam Matadaan, Sabaka Sammaan\" . The event encouraged students to creatively highlight the importance of inclusive voting and civic responsibility, celebrating the power of every voice in our democracy.",
        date: "Date - 25th January 2024",
        venue: "Venue - Online",
        resultLink: "https://channeli.in/noticeboard/notice/19230"
    }
];
